import app from 'flarum/forum/app';
import {extend} from 'flarum/common/extend';
import Page from 'flarum/common/components/Page';
import WelcomeModal from './components/WelcomeModal';

export default function () {
    let initialized = false;

    extend(Page.prototype, 'oninit', function () {
        if (initialized) {
            return;
        }

        if (app.forum.attribute('kilowhatWordpressShowWelcome')) {
            // Use setTimeout to work around "Nested m.redraw.sync() call" error
            setTimeout(() => app.modal.show(WelcomeModal), 0);
        }

        initialized = true;
    });
}
